import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import BreadcrumbNav from '../common/BreadcrumbNav/index.js';
import {HomeOutlined} from '@ant-design/icons';

function NewsNav() {
    const {locale} = useRouter();

    return (
        <div>
            <BreadcrumbNav
                items={[
                    {label: '', href: '/', icon: <HomeOutlined />},
                    {
                        label: getLocaleContent(locale, 'page.news-page.breadcrumb-title'),
                        href: '/tin-tuc',
                        color: '#006940',
                    },
                ]}
            />
        </div>
    );
}

export default NewsNav;
